import React from 'react'
import { StaticQuery, graphql } from "gatsby"
import PostTile from "../components/PostTile";
// https://khalilstemmler.com/articles/gatsby-related-posts-component/
const SimilarArticlesComponent = ({ articles }) => (
  <div className="row">
    {articles.map((article, i) => (
      <div key={`blog-list ${i}`} className={`col-md-6 col-sm-12`}>
        <PostTile post={article.node.frontmatter} fields={article.node.fields} key={i} />
      </div>
    ))}

  </div>


)


function getPostsFromQuery(posts) {
  if (posts) {
    return posts;
  }

  return []
}
// (1.) Query for articles
export default ({ keywords, category, slug = "", author="", displaySomething = false }) => (
  <StaticQuery
    query={graphql`
       query SimilarArticles {
    posts: allMarkdownRemark(
      sort: { fields: [frontmatter___date], order: DESC }
    ) {
      edges {
        node {
          excerpt
          fields {
            slug
            prefix
            readingTime {
              words
            }
          }
          frontmatter {
            title
            date
            category
            description
            keywords
            author
            cover {
                childImageSharp {
                  fluid {
                    ...GatsbyImageSharpFluid
                  }
                }
              } 
            }
          }
        }
      }
    }
    `}
    render={data => {
      if (data.posts.edges) {


        let filteredData = data.posts.edges.filter(p => p.listed);
        if (keywords) {
          filteredData = data.posts.edges.filter(
            post => keywords.find(f => (slug !== post.node.fields.slug) && (post.node.frontmatter.keywords.map(k=>k.toLowerCase()) || []).indexOf(f) > -1)
          );
        }
        if (author) {
          filteredData = data.posts.edges.filter(
            post => post.node.frontmatter.author.toLowerCase() === author.toLowerCase()
          );
        }
        if (category) {
          filteredData =data.posts.edges.filter(
            post => (slug !== post.node.fields.slug) && post.node.frontmatter.category === category
          );
        }
        const articles = getPostsFromQuery(filteredData.length > 0 ? filteredData.slice(0, 4) : displaySomething?data.posts.edges.slice(0, 4):[]);

        // (4.) Render it
        return (
          <SimilarArticlesComponent
            articles={articles}
          />
        )
      } else return <></>;
    }}
  />
)